import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, SwiperOptions } from 'swiper';
import {
  ImageWrapper,
  StyledSwiper,
  SwiperWrap,
  TextWrap,
  Image,
} from '@/components/organisms/navSwiper/NavSwiper.styled';
import { NAVLIST } from '@/const';
import { Subtitle3 } from '@/components/atoms';

SwiperCore.use([Pagination]);

const pagination = {
  clickable: true,
  renderBullet(index: number, className: string) {
    return `<span class=${className}></span>`;
  },
};

const NavSwiper = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const swiperSettings: SwiperOptions = {
    slidesPerView: 2.3,
    spaceBetween: 50,
    centeredSlides: true,
    loop: true,
    pagination,
  };

  const handleSlideChange = (swiper: any) => {
    setActiveIndex(swiper.realIndex);
  };

  const renderComponent = (item: any, index: number) => {
    return (
      <SwiperSlide key={index}>
        <ImageWrapper>
          <Image
            src={`/nav_${item.name}.png`}
            alt={item.name}
            loading={index !== 0 ? 'lazy' : 'eager'}
          />
          {activeIndex === index ? (
            <TextWrap>
              <Subtitle3 color={'white'}>{item.title}</Subtitle3>
            </TextWrap>
          ) : (
            <></>
          )}
        </ImageWrapper>
      </SwiperSlide>
    );
  };

  return (
    <SwiperWrap>
      <StyledSwiper>
        <Swiper {...swiperSettings} onSlideChange={handleSlideChange}>
          {NAVLIST.map((item: any, index: number) => renderComponent(item, index))}
        </Swiper>
      </StyledSwiper>
    </SwiperWrap>
  );
};
export default NavSwiper;
